<header class="registry-header">
  <div class="registry-header__content">
    <div class="registry-header__logo">
      <img src="assets/logo/axon-logo-white.svg" alt="Axon" class="axon-logo" />
    </div>
    <div class="registry-header__actions">
      <fr-language-selector></fr-language-selector>
    </div>
  </div>
</header>

